import type { FlowVariant } from "../funnel/types";
import { resolveFlowFromUrlOrNull } from "../funnel/resolveFlowFromUrl";

export const FLOW_STORAGE_KEY = "vireo:funnel:active-flow";

type InitialFlowResolution = {
  flow: FlowVariant;
  shouldPersistFlow: boolean;
};

export const resolveInitialFlowState = (
  urlLike: URL | string,
  storedFlow: FlowVariant | null,
): InitialFlowResolution => {
  const url = typeof urlLike === "string" ? new URL(urlLike) : urlLike;
  const explicitFlow = resolveFlowFromUrlOrNull(url);

  if (explicitFlow) {
    return { flow: explicitFlow, shouldPersistFlow: true };
  }

  const isStripeReturn = Boolean(url.searchParams.get("session_id")?.trim());
  if (isStripeReturn && storedFlow) {
    return { flow: storedFlow, shouldPersistFlow: false };
  }

  return { flow: "a", shouldPersistFlow: false };
};

export const buildEmbeddedStepPageviewPayload = (
  currentUrl: string,
  flow: FlowVariant,
  stepId: string,
  stepIndex: number,
): Record<string, string | number | boolean> => {
  const url = new URL(currentUrl);
  return {
    $current_url: `${url.origin}${url.pathname}${url.search}#${stepId}`,
    flow_variant: flow,
    funnel_flow: flow,
    funnel_hash_route: `#${stepId}`,
    funnel_step_id: stepId,
    funnel_step_index: stepIndex,
    funnel_embedded_step: true,
  };
};
